import clean from './clean.json';
import pop from './pop.json';
import rap from './rap.json';
import warm from './warm.json';
import radio from './radio.json';

/** Ordered list for the Vocal Presets UI (MVP). */
export const VOCAL_PRESETS = [clean, pop, rap, warm, radio];
